import { useNotification } from "@/context/NotificationContext";
import { useCreateSwarmMutation, useEditOrCreateSwarmMutation, useEditSwarmMutation, useEventsMutation, useLazyGetSwarmsQuery } from "@/services/swarmsApi";
import { selectAllBuyManagers } from "@/store/slices/buyManager/buyManagers";
import { editSwarmForStop, selectAllEvents, selectAllSwarms, updateEvents, updateSwarm } from "@/store/slices/swarms";
import { createErrorMessage } from "@/utils";
import { notRunningSwarmSchema, swarmsSchema } from "@/validations/swarms";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const useSwarmOperations = ({setRows, setLocalEvents, localEvents, hiddenEvents, rowModesModel, setRowModesModel, loadingEvents, swarmEventsRes, errorGettingSwarms, swarmsQueryData,ErrorLoadingEvents}) => {

  const dispatch = useDispatch();
  const [ editSwarm ] = useEditSwarmMutation();
  const [ initSwarmCreation ] = useCreateSwarmMutation();

  const { showNotification } = useNotification();

  const [ editOrCreateSwarm, { data:editedSwarmEvent } ] = useEditOrCreateSwarmMutation();

  const [swarmsUpdating, setSwarmsUpdating] = useState([]);

  const Swarms = useSelector(selectAllSwarms)
  const Events = useSelector(selectAllEvents)
  const buyManagers = useSelector(selectAllBuyManagers)

  async function createSwarm(swarm) {
    try {
      if (swarm.salesDate == "now" || swarm.saleDate == "IsMonitor" || swarm.saleDate == "IsTraining") swarm.salesDate = new Date().toISOString();
      console.log("onStartSwarmClick, createSwarm swarm: ", swarm);
      const data = await initSwarmCreation(swarm).unwrap();
      console.log("onStartSwarmClick, createSwarm data: ", data);
      // setUpdateSwarmInProgress(false);
      // update swarms
      dispatch(updateSwarm(data));
      setRows(prevRows => prevRows.map(row => {
        if (row.bteId === data.bteId) {
          return data;
        }
        return row;
      }));
    } catch (error) {
      // unauthorized
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      console.log("Error creating swarm: ", error);
      // handle error
      throw error;
    }
  };

  async function startSwarm(rowFromDataGrid) {
    console.log("startSwarm rowFromDataGrid: ", rowFromDataGrid);
    let swarm = {
      BteId: rowFromDataGrid.bteId,
      instructions: rowFromDataGrid.instructions,
      code: rowFromDataGrid.code,
      rewardTypeId: rowFromDataGrid.rewardTypeId,
      BuyManagerId: rowFromDataGrid.buyManagerId,
      StrategyTypeId: rowFromDataGrid?.strategyTypeId,
      reward: rowFromDataGrid.reward,
      SalesDate: rowFromDataGrid.salesDate === "now" ? new Date().toISOString() : rowFromDataGrid.salesDate === "IsMonitor" ? new Date().toISOString() : rowFromDataGrid.salesDate === "IsTraining" ? new Date().toISOString() : rowFromDataGrid.salesDate,
      TicketLimit: rowFromDataGrid.eventLimitNumberOfTickets,
      Flag: rowFromDataGrid.flag,
      running: true,
      isMonitor: rowFromDataGrid.salesDate ==="IsMonitor",
      isTraining: rowFromDataGrid.salesDate ==="IsTraining",
      isNow: rowFromDataGrid.salesDate === "now", 
      // buyManagerId: rowFromDataGrid.buyManagerId
    }; 

    try {
      await swarmsSchema.validate(swarm);
    } catch (error) {
      console.log("swarm validation Error: ", error);
      showNotification('You need to fill out all fields 1', 'error');
      return;
    }
    try {
      // setUpdateSwarmInProgress(true);
      let res = await editSwarm(swarm).unwrap();
      console.log("Swarm edited res: ", res);
      // setUpdateSwarmInProgress(false);
      // update swarm state
      dispatch(editSwarmForStop(res));
      setRows(prevRows => prevRows.map(row => {
        if (row.bteId === res.bteId) {
          return {...row, ...res};
        }
        return row;
      }));

    } catch (error) {
      // handle errors
      // unauthorized
      if (error.status == 401) return; // error managed on baseQueryWithReauth

      if (error.status == 404) {
        // the swarm does not exist, create it
        console.log("Swarm, edited failed swarm does not exist, creating it...")
        try {
          await createSwarm(swarm); // TODO: rename functions and variables (and do code review)
        }
        catch (error) {
          console.error("error creating swarm: ", error);
          showNotification(createErrorMessage(error), 'error');
        }
      } else {
        // log unexpected error
        console.error("Error editing swarm: ", error);
        showNotification(createErrorMessage(error), 'error');
        throw error;

      }
    }
  };

  async function stopSwarm(rowFromDataGrid) {
    console.log("stopSwarm rowFromDataGrid: ", rowFromDataGrid);
    let swarm = {
      BteId: rowFromDataGrid.bteId,
      instructions: rowFromDataGrid.instructions,
      code: rowFromDataGrid.code,
      rewardTypeId: rowFromDataGrid.rewardTypeId,
      BuyManagerId: rowFromDataGrid.buyManagerId,
      StrategyTypeId: rowFromDataGrid?.strategyTypeId,
      reward: rowFromDataGrid.reward,
      SalesDate: rowFromDataGrid.salesDate === "now" ? new Date().toISOString() : rowFromDataGrid.salesDate === "IsMonitor" ? new Date().toISOString() :
      rowFromDataGrid.salesDate === "IsTraining" ? new Date().toISOString() : rowFromDataGrid.salesDate,
      TicketLimit: rowFromDataGrid.eventLimitNumberOfTickets,
      Flag: rowFromDataGrid.flag,
      running: true,
      isMonitor: rowFromDataGrid.salesDate ==="IsMonitor",
      isTraining: rowFromDataGrid.salesDate === "IsTraining",
      isNow: rowFromDataGrid.salesDate === "now",
    };
    try {
      await notRunningSwarmSchema.validate(swarm);
    } catch (error) {
      console.log("swarm validation Error: ", error);
      showNotification('You need to fill out all fields 2', 'error');
      return;
    }
    try {
      // setUpdateSwarmInProgress(true);
      let res = await editSwarm({
        Id: rowFromDataGrid.swarmId,
        bteId: rowFromDataGrid.bteId,
        running: false,
      }).unwrap();
      // setUpdateSwarmInProgress(false);
      console.log("Swarm stopped", res);
      // update swarm state
      dispatch(editSwarmForStop(res));
      setRows(prevRows => prevRows.map(row => {
        if (row.bteId === res.bteId) {
          return {...row, ...res};
        }
        return row;
      }));
    } catch (error) {
      // unauthorized
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      // log
      console.log("Error editing swarm: ", error);
      // handle error
      showNotification(createErrorMessage(error), 'error');
      throw error;
    }
  };

  function mergeSwarmsAndEvents(events, swarms, rowModesModel, ) {
    function getSaleDate(event, swarmInformationByEventId) {
      // DBG:
      // console.log("event: ", event)
      // console.log("event: ", swarmInformationByEventId[event.bteId])
      let saleDateExists = swarmInformationByEventId[event.bteId]?.salesDate;
      let swarmIsToday = swarmInformationByEventId[event.bteId]?.isNow;
      let swarmIsMonitor = swarmInformationByEventId[event.bteId]?.isMonitor;
      let swarmIsTraining = swarmInformationByEventId[event.bteId]?.isTraining;
      if (!saleDateExists || swarmIsToday){
        return "now"
      } else if (!saleDateExists || swarmIsMonitor) {
        return "IsMonitor"
      } else if (!saleDateExists || swarmIsTraining) {
        return "IsTraining"
      } else {
        return swarmInformationByEventId[event.bteId]?.salesDate;
      }
    }
    let merged = [];
    let swarmInformationByEventId = {};
    swarms.forEach((swarm) => { swarmInformationByEventId[swarm.bteId] = swarm; });
    events.forEach((storeEvent) => {
      let event = storeEvent
      let swarmInfo = swarmInformationByEventId[storeEvent.bteId];
      // if(editedSwarmEvent?.event?.bteId == storeEvent.bteId){
      //   console.log("Editing event: ", storeEvent, editedSwarmEvent)
      //   event = editedSwarmEvent.event
      //   swarmInfo = editedSwarmEvent.swarm
      // }
      const isInEditMode = rowModesModel[storeEvent.bteId]?.mode;
      merged.push({
        bteId: storeEvent.bteId,
        name: event.name,
        date: event.date,
        primaryEventUrl: event.primaryEventUrl,
        salesDates: event.salesDates,
        eventLimitNumberOfTickets: event.useRunLevelLimit ? event.runLimitNumberOfTickets : event.eventLimitNumberOfTickets,
        code: swarmInfo?.code || "",
        instructions: swarmInfo?.instructions || "",
        reward: swarmInfo?.reward || 1,
        rewardTypeId: swarmInfo?.rewardTypeId || 1,
        isNow: swarmInfo?.isNow || false,
        isMonitor: swarmInfo?.isMonitor || false,
        isTraining: swarmInfo?.isTraining || false,
        running: swarmInfo?.running || false,
        salesDate: getSaleDate(event, swarmInformationByEventId), //A: default value "now"
        swarmId: swarmInfo?.id,
        flag: swarmInfo?.flag || false,
        venue: event?.venue,
        isInEditMode: isInEditMode,
        useRunLevelLimit: event.useRunLevelLimit,
        runId: event.runId,
        buyManagerId: swarmInfo?.buyManagerId,
        strategyTypeId: swarmInfo?.strategyTypeId,
        entityLink: event?.entityLink,
        alternativeEventUrl: swarmInfo?.alternativeEventUrl,
        isAutoBuyActive: swarmInfo?.isAutoBuyActive
      });
    });
    return merged;
  }

  useEffect(() => {
    if (!loadingEvents && !ErrorLoadingEvents &&!errorGettingSwarms && Swarms && Events && localEvents) {
      const filteredEvents = localEvents?.filter(event => !(hiddenEvents ?? []).includes(event.bteId)) || [];
      const currentEvents = filteredEvents.map(resEvent => {
        if(Events?.includes(resEvent.bteId)){
          return Events.find(event => event.bteId === resEvent.bteId)
        }else{
          return resEvent
        }
      });
      let merged = mergeSwarmsAndEvents(currentEvents, Swarms, rowModesModel, editedSwarmEvent);
      setRows(merged);
    }
  }, [localEvents, swarmsQueryData, loadingEvents, ErrorLoadingEvents, Swarms, Events, errorGettingSwarms, hiddenEvents, buyManagers, editedSwarmEvent]);

  const processRowUpdate = useCallback(async (swarmUpdated, oldValue) => {
    console.log("swarmUpdated : " + JSON.stringify(swarmUpdated));
    let aux = { ...swarmUpdated };
    setSwarmsUpdating([...swarmsUpdating, aux.bteId])
    aux.id = swarmUpdated.swarmId;

    if (aux.salesDate == "now") {
      aux.isNow = true;
      aux.isMonitor = false;
      aux.salesDate = new Date().toISOString();
      aux.isTraining = false;
    } else if (aux.salesDate=="IsMonitor") {
      aux.isNow = false;
      aux.isMonitor = true;
      aux.salesDate = new Date().toISOString();
      aux.isTraining = false;
    } else if (aux.salesDate=="IsTraining") { 
      aux.isNow = false;
      aux.isMonitor = false;
      aux.isTraining = true;
      aux.salesDate = new Date().toISOString();
    } else {
      aux.isNow = false;
      aux.isMonitor = false;
      aux.isTraining = false;
    }

    try {
      let response = await editOrCreateSwarm(aux).unwrap()
      dispatch(updateSwarm(response.swarm));
      dispatch(updateEvents([response.event]));
      setLocalEvents(prevLocalEvents => prevLocalEvents.map(event => {
        if (event.bteId === response.event.bteId) {
          return response.event;
        }
        return event;
      }));
      console.log("response: ", response)
      let updatedRow = {
        ...response.swarm,
        ...response.event,
        salesDates: response.event.salesDates,
        entityLink: response.event.entityLink
      };
      // ! IMPORTANT!!!!!!!!!!!!
      swarmUpdated={...updatedRow, salesDate: updatedRow.isNow ? "now" : updatedRow.isMonitor ? "IsMonitor" : updatedRow.isTraining ? "IsTraining" : updatedRow.salesDate};
      // ! IMPORTANT!!!!!!!!!!!!

      console.log("ROWS UPDATED BY PROCESSROWUPDATE: ", swarmUpdated);
      setRows(prevRows => prevRows.map(row => {
        if (row.bteId === aux.bteId) {
          console.log("ROWS UPDATED BY PROCESSROWUPDATE 2: ", swarmUpdated, row, aux)
          return swarmUpdated
        }
        return row;
      }));

    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      console.log("error: ", error)
      showNotification(createErrorMessage(error), 'error');
      setSwarmsUpdating([...swarmsUpdating].filter(x => x === aux.bteId));
      return oldValue; //A: we return oldValue to cancel the edit.
    }
    setSwarmsUpdating([...swarmsUpdating].filter(x => x === aux.bteId));
    console.log("swarmUpdated: ", swarmUpdated);
    return swarmUpdated;
  },[editSwarm, dispatch, setRows]);


  return { startSwarm, stopSwarm, createSwarm, processRowUpdate, swarmsUpdating, setSwarmsUpdating, loadingEvents, swarmEventsRes };
};

export default useSwarmOperations;
